import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  dateRange: {
    startDate: "",
    endDate: "",
  },
  isAlreadyPauseModalOpen: false,
  isFetchedFromServer: false,
  pauseModalData: {},
};
const studentPauseSlice = createSlice({
  name: "studentPause",
  initialState,
  reducers: {
    setDateRange: (state, action) => {
      state.dateRange = { ...action.payload };
    },
    setAlreadyPauseModalOpen: (state, action) => {
      state.isAlreadyPauseModalOpen = action.payload;
    },
    setIsFetchedFromServer: (state, action) => {
      state.isFetchedFromServer = action.payload;
    },
    setPauseModalData: (state, action) => {
      state.pauseModalData = { ...action.payload };
    },
  },
});

export const {
  setDateRange,
  setAlreadyPauseModalOpen,
  setIsFetchedFromServer,
  setPauseModalData,
} = studentPauseSlice.actions;
export const fetchFromServerStatus = (state) =>
  state.studentPause.isFetchedFromServer;
export default studentPauseSlice.reducer;
